// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlagTwoToneSvg from "@fishx/icons-svg/es/asn/FlagTwoTone";
import FishxIcon from '../components/FishxIcon';

var FlagTwoTone = function FlagTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FlagTwoToneSvg
  }));
};

FlagTwoTone.displayName = 'FlagTwoTone';
export default React.forwardRef(FlagTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FlagTwoTone.js
// module id = 2794
// module chunks = 0